import { ArrowRight, ContactBand, Feature, PageHero, SectionHeading } from '../../components/Layout';

const values = [
  {
    title: 'UK-based professionals',
    text: 'Our agents are based in the UK, ensuring clear communication and cultural alignment with your customers.',
  },
  {
    title: 'GDPR compliant',
    text: 'All client and customer data is handled with care. Your information and your customers privacy are protected.',
  },
  {
    title: 'Transparent reporting',
    text: 'No black boxes. You see exactly what happened, what was escalated, and what needs follow-up.',
  },
  {
    title: 'Built for growth',
    text: 'Start small and scale as you grow. Our support adapts to your volume without disruption.',
  },
];

export default function AboutPage({ onNavigate }) {
  return (
    <>
      <PageHero
        eyebrow="About ClearDesk"
        title="Experienced support operators with a practical, process-first approach."
        text="ClearDesk Support Ltd helps small and growing companies deliver dependable customer communication without building a large in-house team."
        backgroundImage="../../abouthero.webp"
      />
      <div className="section-pad">
        <div className="about-layout">
          <div>
            <p className="eyebrow">Working approach</p>
            <h2>We operate like an extension of your business.</h2>
            <p>
              Our approach is simple: understand your customer journey, document the right response process, then
              operate with consistency. We focus on reducing missed enquiries, improving follow-up, and giving owners
              and managers more breathing room.
            </p>
            <p style={{ marginTop: 14 }}>
              Whether you need daily reception coverage or targeted overflow support, ClearDesk builds around your
              tools, standards, and preferred way of communicating with customers.
            </p>
            <div style={{ marginTop: 28, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <button className="btn primary" onClick={() => onNavigate('/contact')}>Get started <ArrowRight /></button>
              <button className="btn outline-blue" onClick={() => onNavigate('/services')}>View services</button>
            </div>
          </div>
          <div className="approach-panel">
            <Feature title="Listen first" text="We learn your business, customer types, and common requests before taking over customer-facing tasks." lightBg />
            <Feature title="Document clearly" text="Call scripts, booking rules, and escalation paths are kept practical and easy to update." lightBg />
            <Feature title="Improve continuously" text="We use feedback and enquiry patterns to make the support experience smoother over time." lightBg />
          </div>
        </div>

        <div style={{ marginTop: 72 }}>
          <SectionHeading eyebrow="Our values" title="How we show up every day" />
          <div className="reason-grid">
            {values.map((value) => <Feature key={value.title} title={value.title} text={value.text} lightBg />)}
          </div>
        </div>
      </div>
      <ContactBand onNavigate={onNavigate} />
    </>
  );
}
